import { Box, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { statesByAbbrev, territoriesByAbbrev } from '@scoir/states'
import { HSLocation, unknownLocation } from '../types'

export const unknownLocationOption = {
  name: 'International',
  value: unknownLocation,
}

const options = [
  ...Object.values(statesByAbbrev).map((state) => state.value),
  ...Object.values(territoriesByAbbrev).map((territory) => territory.value),
  unknownLocationOption.value,
]

const LocationFilter = ({
  selectedLocations,
  onChangeLocation,
}: {
  selectedLocations?: HSLocation[]
  onChangeLocation: (newLocations: HSLocation[]) => void
}) => {
  return (
    <Box>
      <Typography variant="body1">States</Typography>
      <Autocomplete
        value={selectedLocations ?? []}
        multiple
        filterSelectedOptions
        options={options}
        disableCloseOnSelect
        ChipProps={{ color: 'primary', variant: 'outlined' }}
        getOptionLabel={(option) => {
          if (option === unknownLocationOption.value) {
            return unknownLocationOption.name
          }
          return (
            statesByAbbrev[option as keyof typeof statesByAbbrev]?.name ||
            territoriesByAbbrev[option as keyof typeof territoriesByAbbrev]?.name ||
            option
          )
        }}
        onChange={(_, newValue) => onChangeLocation(newValue as HSLocation[])}
        renderInput={(params) => (
          <TextField
            {...params}
            color="primary"
            variant="outlined"
            placeholder="Add Location"
            aria-label="Location Filter"
          />
        )}
      />
    </Box>
  )
}

export default LocationFilter
